import { Menu, type MenuMultiSelectGroupProps, Text } from "@overmap-ai/blocks"
import type { AssetType, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { AssetTypeIcon } from "../Icons/AssetTypeIcon"
import { MultiSelectItemTemplate, SelectAllItemTemplate } from "../MenuGroups/constants"

export interface AssetTypeMultiSelectGroupProps extends MenuMultiSelectGroupProps<Stored<AssetType>> {
	assetTypes: Stored<AssetType>[]
}

export const AssetTypeMultiSelectGroup = memo<AssetTypeMultiSelectGroupProps>((props) => {
	const { ref, assetTypes, ...rest } = props

	return (
		<Menu.MultiSelectGroup<Stored<AssetType>> ref={ref} {...rest}>
			<SelectAllItemTemplate>Select all</SelectAllItemTemplate>
			{assetTypes.map((assetType) => {
				return (
					<MultiSelectItemTemplate<Stored<AssetType>> key={assetType.uuid} value={assetType}>
						<AssetTypeIcon assetTypeId={assetType.uuid} />
						<Text className="truncate">{assetType.name}</Text>
					</MultiSelectItemTemplate>
				)
			})}
		</Menu.MultiSelectGroup>
	)
})
AssetTypeMultiSelectGroup.displayName = "AssetTypeMultiSelectGroup"
